import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import LanguagesContent from './LanguagesContent'
export default class Languages extends Component {

    

    render() {

        let id = this.props.match.params.id;
       
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <LanguagesContent id={id} />
                <Footer />

            </div>


        )
    }
}
